import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { App } from './app.tsx';
import * as errorReporting from './utils/errorReporting.ts';
import { trpc, trpcClient } from './utils/trpc/trpc.ts';


let rootOptions: ReactDOM.RootOptions | undefined;
if (errorReporting.isEnabled()) {
    errorReporting.init();

    const handleReactError = errorReporting.createReactErrorHandler();
    rootOptions = {
        onCaughtError: handleReactError,
        onUncaughtError: handleReactError,
        onRecoverableError: handleReactError,
    }
}

const queryClient = new QueryClient({});


ReactDOM.createRoot(document.getElementById('root')!, rootOptions).render(
    <StrictMode>
        <trpc.Provider queryClient={queryClient} client={trpcClient}>
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </trpc.Provider>
    </StrictMode>
)
